import React, { useState } from 'react';
import './Header.css';

export default function Header() {
  const [activeTab, setActiveTab] = useState('stays');

  const navTabs = [
    { id: 'stays', icon: '🛏️', label: 'Stays' },
    { id: 'flights', icon: '✈️', label: 'Flights' },
    { id: 'cars', icon: '🚗', label: 'Car rentals' },
    { id: 'attractions', icon: '🎟️', label: 'Attractions' },
    { id: 'taxis', icon: '🚕', label: 'Airport taxis' },
  ];

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <a href="/" className="brand">
          <span className="mark">A</span>
          <span>
            Ammy Services
            <small>HOTELS · FLIGHTS · CABS · TRIPS</small>
          </span>
        </a>
        <div className="topbar-actions">
          <button className="pill">INR ₹</button>
          <button className="circle" title="Language">
            🇮🇳
          </button>
          <button className="pill" onClick={() => {}}>
            List your property
          </button>
          <button className="pill btn-ghost" onClick={() => {}}>
            Register
          </button>
          <button className="pill btn-white" onClick={() => {}}>
            Sign in
          </button>
        </div>
      </div>

      <nav className="tabs">
        <ul>
          {navTabs.map((tab) => (
            <li key={tab.id} className={activeTab === tab.id ? 'active' : ''}>
              <button onClick={() => setActiveTab(tab.id)} className="nav-tab">
                <span className="ico">{tab.icon}</span>
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
